(function () {
  var LOOP = '<svg class="ep-tl" viewBox="0 0 48 48" aria-hidden="true" focusable="false"><circle class="ep-tl__thread" cx="24" cy="24" r="19"/><ellipse class="ep-tl__eye" cx="24" cy="5" rx="4.4" ry="2.4"/></svg>';

  /* Soft veil while the next page loads */
  var veil, showTimer, safetyTimer;
  function showVeil() {
    if (!veil) {
      veil = document.createElement('div');
      veil.className = 'ep-veil';
      veil.setAttribute('aria-hidden', 'true');
      veil.innerHTML = LOOP;
      document.body.appendChild(veil);
      void veil.offsetWidth;
    }
    veil.classList.add('is-on');
    clearTimeout(safetyTimer);
    safetyTimer = setTimeout(hideVeil, 8000);
  }
  function hideVeil() {
    clearTimeout(showTimer);
    clearTimeout(safetyTimer);
    if (veil) veil.classList.remove('is-on');
  }
  function isPageLink(a) {
    if (a.target && a.target !== '_self') return false;
    if (a.hasAttribute('download') || a.closest('[data-no-veil]')) return false;
    var url;
    try { url = new URL(a.href, location.href); } catch (e) { return false; }
    if (!/^https?:$/.test(url.protocol) || url.origin !== location.origin) return false;
    if (url.pathname === location.pathname && url.search === location.search) return false;
    return true;
  }
  document.addEventListener('click', function (e) {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    setTimeout(function () {
      if (e.defaultPrevented || !isPageLink(a)) return;
      clearTimeout(showTimer);
      showTimer = setTimeout(showVeil, 250);
    }, 0);
  });
  window.addEventListener('pageshow', hideVeil);

  /* Fade lazy images in over the woven placeholder */
  var FRAMES = '.ep-pc__media, .ep-pd__slide--image, .ep-ac__media, .ep-cat__arch, .ep-occ__media, .ep-story__fig, .ep-feature__media, .ep-ar__rte figure, .media';
  function settle(img) {
    if (!img.classList.contains('ep-ph-wait')) return;
    img.classList.remove('ep-ph-wait');
    img.classList.add('ep-ph-in');
  }
  document.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
    if (img.complete || img.classList.contains('ep-pc__img--alt') || !img.closest(FRAMES)) return;
    img.classList.add('ep-ph-wait');
    img.addEventListener('load', function () { settle(img); }, { once: true });
  });
})();
